import { z } from 'zod';

export const javascriptKeywords = [
  'case',
  'const',
  'continue',
  'default',
  'delete',
  'export',
  'extends',
  'false',
  'finally',
  'in',
  'instanceof',
  'let',
  'new',
  'return',
  'static',
  'super',
  'switch',
  'this',
  'throw',
  'true',
  'typeof',
  'var',
  'yield',
];

const reservedKeywords = [
  ...javascriptKeywords,
  'abstract',
  'await',
  'break',
  'catch',
  'class',
  'debugger',
  'do',
  'else',
  'for',
  'function',
  'if',
  'import',
  'try',
  'void',
  'while',
  'with',
  'any',
  'as',
  'bigint',
  'boolean',
  'constructor',
  'declare',
  'default',
  'enum',
  'implements',
  'infer',
  'interface',
  'is',
  'module',
  'namespace',
  'never',
  'null',
  'number',
  'object',
  'protected',
  'public',
  'readonly',
  'string',
  'satisfies',
  'symbol',
  'type',
  'unique',
  'undefined',
  'unknown',
  'void',
  'when',
];

export const IdentifierNameSchema = z
  .string({ message: 'Name is required' })
  .min(1, 'Name is required')
  .max(64, 'Name must be less than 64 characters')
  .refine((value) => !reservedKeywords.includes(value), 'Name cannot be a reserved word')
  .refine((value) => !/\s/.test(value), 'Name cannot contain spaces')
  .refine((value) => !/^\d/.test(value), 'Name cannot start with a number')
  .refine((value) => !/[^\s\w]/.test(value), 'Name cannot contain special characters');

export const FlowKeywords = {
  // Properties of each block
  data: 'data',
  error: 'error',
  metadata: 'metadata',
  config: 'config',
  state: 'state',
  startTime: 'startTime',
  endTime: 'endTime',
  duration: 'duration',
  // Global for a flow's input parameters
  inputs: 'inputs',
  // Globals within an iterator or repeat block
  element: 'element',
  lastResult: 'lastResult',
  index: 'index',
} as const;

// Properties of each block
export const blockFieldNames: readonly string[] = [
  FlowKeywords.data,
  FlowKeywords.error,
  FlowKeywords.metadata,
  FlowKeywords.startTime,
  FlowKeywords.endTime,
  FlowKeywords.duration,
  FlowKeywords.config,
  FlowKeywords.state,
];

export const reservedBlockNames: readonly string[] = [
  FlowKeywords.inputs,
  FlowKeywords.element,
  FlowKeywords.lastResult,
  FlowKeywords.index,
];
